import Vue from 'vue'
import VueRouter from 'vue-router'

import Hello from './components/Hello';
import Projects from './components/Projects';
import Other from './components/Other';

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {
            path: '/',
            name: 'hello',
            component: Hello
        },
        {
            path: '/projects',
            name: 'projects',
            component: Projects
        },
        {
            path: '/more',
            name: 'more',
            component: Other
        },
    ]
});
  
export default router